
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workshops/[slug]",
      function () {
        return require("private-next-pages/workshops/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workshops/[slug]"])
      });
    }
  